import { render, staticRenderFns } from "./PageSkeletonTabs.vue?vue&type=template&id=f97d9a9a&scoped=true"
import script from "./PageSkeletonTabs.vue?vue&type=script&lang=js"
export * from "./PageSkeletonTabs.vue?vue&type=script&lang=js"
import style0 from "./PageSkeletonTabs.vue?vue&type=style&index=0&id=f97d9a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97d9a9a",
  null
  
)

export default component.exports